import { computed, type Ref } from 'vue';
import { useQuery } from '@vue/apollo-composable';
import { GET_STUDENT_DATA_REQUEST_FIELD_CHOICES } from '@/graphql/studentDataRequests';
import type {
  StudentDataRequestFieldChoicesQuery, StudentDataRequestFieldChoicesQueryVariables,
} from '@/types/operations';

/** The fields a data request may ask for: those students of this school may fill in. */
export function useStudentDataRequestFieldChoices(options: { enabled?: Ref<boolean> } = {}) {
  const { result, loading, error, refetch } = useQuery<StudentDataRequestFieldChoicesQuery, StudentDataRequestFieldChoicesQueryVariables>(
    GET_STUDENT_DATA_REQUEST_FIELD_CHOICES,
    {},
    () => ({ fetchPolicy: 'cache-and-network', enabled: options.enabled?.value ?? true }),
  );

  return {
    choices: computed(() => result.value?.studentDataRequestFieldChoices ?? []),
    loading,
    error,
    refetch,
  };
}
